module.exports = __webpack_public_path__ + "img/lnu_logo.13d61234.jpg";